import { AbacoVuexModule, State } from "@abaco/web-common/src/app";

export default class CruscottoLoggingApplicativoVuexModule extends AbacoVuexModule {

}
